export const textStrings = {
  humanProject: {
    title: 'purpose & potential',
    subtitle: 'Moments where we are connected to our',
    text: `These are moments of learning and growth; achievement and mastery; meaning and self-actualization. We might take on new roles, go after personal goals, gain new knowledge, grow our skills, challenge our beliefs, and stretch what we think is possible.`,
  },
  cultureAndSpirit: {
    title: 'culture & spirit',
    subtitle: 'Moments where we are connected to ',
    text: `These are moments where we feel part of something bigger than ourselves. We might experience a sense of balance, faith, awe, and/or beauty.`,
  },
  selfAndBody: {
    title: 'bodies & selves',
    subtitle: 'Moments where we are connected to our',
    text: `These are moments where we use our senses to get to know all parts of ourselves. They can be moments of rest and relaxation, energy and exertion, feeling and pleasure, self-awareness and reflection. `,
  },
  others: {
    title: 'friends, family & community',
    subtitle: 'Moments where we are connected to',
    text: `These are moments where we feel loved, respected, and like we belong. They might be moments of friendship, romance, care, and/or togetherness. `,
  },
  socialJustice: {
    title: 'power & justice',
    subtitle: 'Moments where we are connected to',
    text: `These are moments where we feel our voices are heard and our lived experiences matter. We might advocate, educate, organize, and make decisions.`,
  },
  place: {
    title: 'place',
    subtitle: 'Moments where we are connected to',
    text: `These are moments where we feel grounded and in relationship to what's physically around us. They might be moments of meeting neighbours, nurturing plants and animals, and navigating our environments.`,
  },
};
